import { observer } from "mobx-react-lite";
import { ChangeEventViewButton } from "./ChaneEventViewButton";
import { useContext, useState } from "react";
import { storeContext } from "../../../../store/root-store";

export enum ViewComponents {
  textOverImg = "textOverImg",
  vertical = "vertical",
}

export interface IEventViewManagmentPanel {}
export const EventViewManagmentPanel = observer(() => {
  const { settingsGl } = useContext(storeContext);
  const [currentStateButtton, setCurrentStateButton] = useState<ViewComponents>(
    settingsGl.currentComponentViewState
  );
  const onChangeViewButtonState = (
    newState: boolean,
    buttonName: ViewComponents
  ) => {
    // alert("hello")
    if (newState) {
      // alert(newState + ' - состояние');
      settingsGl.changeCurrentViewState(buttonName);

      // setCurrentStateButton(currentStateButtton);
    }
    else {
      
    }
    console.log(newState, buttonName);
  };

  return (
    <div className="d-flex justify-content-end">
      <div className="list-of-buttons d-flex">
        <ChangeEventViewButton
          currentGlobalValue={settingsGl.currentComponentViewState}
          onChaneState={onChangeViewButtonState}
          activeClass="bi-1-circle-fill"
          activePath="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M9.283 4.002H7.971L6.072 5.385v1.271l1.834-1.318h.065V12h1.312z"
          defaultClass="bi-1-circle"
          defaultPath="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M9.283 4.002V12H7.971V5.338h-.065L6.072 6.656V5.385l1.899-1.383z"
          defaultValue={
            settingsGl.currentComponentViewState == ViewComponents.textOverImg
          }
          // defaultValue={true}
          buttonName={ViewComponents.textOverImg}
        ></ChangeEventViewButton>
        {/* {settingsGl.currentComponentViewState} */}
        <ChangeEventViewButton
          currentGlobalValue={settingsGl.currentComponentViewState}
          onChaneState={onChangeViewButtonState}
          activeClass="bi-2-circle-fill"
          activePath="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.646 6.24c0-.691.493-1.306 1.336-1.306.756 0 1.313.492 1.313 1.236 0 .697-.469 1.23-.902 1.705l-2.971 3.293V12h5.344v-1.107H7.268v-.077l1.974-2.22.096-.107c.688-.763 1.287-1.428 1.287-2.43 0-1.266-1.031-2.215-2.613-2.215-1.758 0-2.637 1.19-2.637 2.402v.065h1.271v-.07Z"
          defaultClass="bi-2-circle"
          defaultPath="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.646 6.24v.07H5.375v-.064c0-1.213.879-2.402 2.637-2.402 1.582 0 2.613.949 2.613 2.215 0 1.002-.6 1.667-1.287 2.43l-.096.107-1.974 2.22v.077h3.498V12H5.422v-.832l2.97-3.293c.434-.475.903-1.008.903-1.705 0-.744-.557-1.236-1.313-1.236-.843 0-1.336.615-1.336 1.306"
          defaultValue={
            settingsGl.currentComponentViewState == ViewComponents.vertical
          }
          // defaultValue={true}
          buttonName={ViewComponents.vertical}
        ></ChangeEventViewButton>
      </div>
    </div>
  );
});
